import { ActionIcon, Collapse, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

import { Content, NoContentPlaceholder } from '@/core/components';

import { ValidationCard } from '@feature/validation/ValidationCard';
import { Validation } from '@feature/validation/ValidationTypes';

interface ValidationHistoryBoxProps {
  history: Validation[];
  defaultIsCollapsed?: boolean;
}

export function ValidationHistoryContent({ history, defaultIsCollapsed }: ValidationHistoryBoxProps) {
  const [opened, { toggle }] = useDisclosure(!defaultIsCollapsed);
  if (history.length == 0) return null;

  return (
    <Content type="full">
      <Group gap="4px">
        <Text fw="500">Istoric de validări</Text>
        <ActionIcon
          onClick={toggle}
          variant="subtle"
          aria-label="colapsează"
        >
          {!opened && (
            <IconChevronDown
              style={{ width: '70%', height: '70%' }}
              stroke={1.5}
            />
          )}
          {opened && (
            <IconChevronUp
              style={{ width: '70%', height: '70%' }}
              stroke={1.5}
            />
          )}
        </ActionIcon>
      </Group>
      <Collapse in={opened}>
        {history.length === 0 && <NoContentPlaceholder title="Nu există un istoric al validărilor" />}
        <Stack>
          {history.map(item => (
            <ValidationCard
              key={item.id}
              validation={item}
            />
          ))}
        </Stack>
      </Collapse>
    </Content>
  );
}
